export function ensureArray(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.content)) return data.content;
  if (Array.isArray(data.positions)) return data.positions;
  if (Array.isArray(data.signals)) return data.signals;
  if (Array.isArray(data.symbols)) return data.symbols;
  if (Array.isArray(data.result)) return data.result;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.rows)) return data.rows;
  if (Array.isArray(data.signalRequests)) return data.signalRequests;
  return [];
}
